import Axios from "../../configs/axios.config";

// export const createHouse = (data) => Axios.post(`/house`, data).then(response=>response.data.data);
// export const updateHouse = (data, id) => Axios.put(`/house/${id}`, data).then(response=>response.data.data);
// export const getHouseList = (data) => Axios.get('/house', { params: data }).then(response=>response.data.data);
// export const getHouseDetail = (id) => Axios.get(`/house/${id}`).then(response=>response.data.data);
// export const deleteHouse = (id) => Axios.delete(`/house/${id}`);

// export const assionHouse = (data) => Axios.post(`/student-house`, data).then(response=>response.data.data);


export const getPaymentHistoryList = (data) => Axios.get('/payment/history', { params: data }).then(response=>response.data.data);
export const getPackageHistoryList = (data) => Axios.get('/payment/package-history', { params: data }).then(response=>response.data.data);
export const getStorageHistoryList = (data) => Axios.get('/payment/storage-history', { params: data }).then(response=>response.data.data);
export const getPaymentHistoryDetail = (id) => Axios.get(`/payment/history-detail/${id}`).then(response=>response.data.data);